import type {
  LoadDeviceConfigurationFailed,
  LoadDeviceConfigurationRequest,
  LoadDeviceConfigurationSucceded,
  UpdateDeviceConfigurationRequestFailed,
  UpdateDeviceConfigurationRequestRequest,
  UpdateDeviceConfigurationRequestSucceded,
  UpdateDeviceSpeedRequestFailed,
  UpdateDeviceSpeedRequestRequest,
  UpdateDeviceSpeedRequestSucceded,
} from './actions';
import { ActionTypes } from './actionTypes';

import type {
  DeviceConfiguration,
  PageableContent,
  Sort,
  UpdateDeviceConfiguration,
} from '@cobliteam/common-types';

export const loadDeviceConfigurationRequest = (
  page?: number,
  size?: number,
  sort?: Sort,
  deviceIds?: string[]
): LoadDeviceConfigurationRequest => ({
  type: ActionTypes.LOAD_DEVICE_CONFIGURATION_REQUEST,
  payload: { page, size, sort, deviceIds },
});

export const loadDeviceConfigurationSucceded = (
  deviceConfigurationPage: PageableContent<DeviceConfiguration>
): LoadDeviceConfigurationSucceded => ({
  type: ActionTypes.LOAD_DEVICE_CONFIGURATION_SUCCEDED,
  payload: deviceConfigurationPage,
});

export const loadDeviceConfigurationFailed =
  (): LoadDeviceConfigurationFailed => ({
    type: ActionTypes.LOAD_DEVICE_CONFIGURATION_FAILED,
  });

export const updateDeviceConfigurationRequest = (
  updateDeviceConfiguration: UpdateDeviceConfiguration[]
): UpdateDeviceConfigurationRequestRequest => ({
  type: ActionTypes.UPDATE_DEVICE_CONFIGURATION_REQUEST_REQUEST,
  payload: updateDeviceConfiguration,
});

export const updateDeviceConfigurationSucceded = (
  updateDeviceConfiguration: UpdateDeviceConfiguration[]
): UpdateDeviceConfigurationRequestSucceded => ({
  type: ActionTypes.UPDATE_DEVICE_CONFIGURATION_REQUEST_SUCCEDED,
  payload: updateDeviceConfiguration,
});

export const updateDeviceConfigurationFailed =
  (): UpdateDeviceConfigurationRequestFailed => ({
    type: ActionTypes.UPDATE_DEVICE_CONFIGURATION_REQUEST_FAILED,
  });

export const updateDeviceSpeedRequest = (
  updateDeviceConfiguration: UpdateDeviceConfiguration
): UpdateDeviceSpeedRequestRequest => ({
  type: ActionTypes.UPDATE_DEVICE_SPEED_REQUEST_REQUEST,
  payload: updateDeviceConfiguration,
});

export const updateDeviceSpeedSucceded = (
  updateDeviceSpeed: UpdateDeviceConfiguration
): UpdateDeviceSpeedRequestSucceded => ({
  type: ActionTypes.UPDATE_DEVICE_SPEED_REQUEST_SUCCEDED,
  payload: updateDeviceSpeed,
});

export const updateDeviceSpeedFailed = (): UpdateDeviceSpeedRequestFailed => ({
  type: ActionTypes.UPDATE_DEVICE_SPEED_REQUEST_FAILED,
});
